import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'src/components/Loader';
import { TableRowProvider } from 'src/utils/context/TableRowContext';
import DataGridColumns from './DataGridColumns';
import DataGridItem from './DataGridItem';
import { getObjectFields } from './utils';
import Styled from './DataGrid.styles';

const DataGridTable = ({ items, item, columns, loading, onDelete, ...rest }) => {
  const gridColumns = (!columns && getObjectFields(items[0])) || [];
  return (
    <Styled.Table withColumns={true} {...rest}>
      {!columns && <DataGridColumns columns={gridColumns} />}
      {columns && columns()}

      {loading && <Loader />}
      <Styled.TableItems>
        {items.map((i, index) => {
          return (
            <TableRowProvider key={i.id} value={{ ...i, index, onDelete }}>
              {(item && item(i, index)) || <DataGridItem key={i.id} item={i} />}
            </TableRowProvider>
          );
        })}
      </Styled.TableItems>
    </Styled.Table>
  );
};

DataGridTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.func,
  item: PropTypes.func,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
};

DataGridTable.defaultProps = {
  columns: null,
  item: null,
  loading: false,
};

export default React.memo(DataGridTable);
